import React from "react";
import { Link } from 'react-router-dom';
import LoaderMin from "components/blocks/Loader/LoaderMin";
import Icon from "components/blocks/Icon/Icon";
import NoData from "components/pages/noData/NoData";
import { useGeneralManagementState } from "./generalManagementState";

const getCardMeta = (tipo) => {
  if (tipo === 2) return { iconName: "download", iconMod: "--download" };
  if (tipo === 1) return { iconName: "external", iconMod: "" };
  return { iconName: "file-text", iconMod: "--form" };
};

const GestionCard = ({ item, onClickHandler, linkTo, linkState }) => {
  const { iconName, iconMod } = getCardMeta(item.Tipo);

  if (item.Tipo === 1) {
    return (
      <article className="mgmt-item-card" onClick={onClickHandler}>
        <div className={`mgmt-item-card__icon${iconMod ? ` mgmt-item-card__icon${iconMod}` : ""}`}>
          <Icon name={iconName} size={20} />
        </div>
        <div className="mgmt-item-card__body">
          <div className="mgmt-item-card__title">{item.Titulo}</div>
          {item.Descripcion && <div className="mgmt-item-card__desc">{item.Descripcion}</div>}
        </div>
        <div className="mgmt-item-card__action">
          <span className="mgmt-item-card__btn">Ver <Icon name="arrow-right" size={13} /></span>
        </div>
      </article>
    );
  }

  if (item.Tipo === 2) {
    return (
      <article className="mgmt-item-card mgmt-item-card--static">
        <div className="mgmt-item-card__icon mgmt-item-card__icon--download">
          <Icon name={iconName} size={20} />
        </div>
        <div className="mgmt-item-card__body">
          <div className="mgmt-item-card__title">{item.Titulo}</div>
          {item.Descripcion && <div className="mgmt-item-card__desc">{item.Descripcion}</div>}
        </div>
        <div className="mgmt-item-card__action">
          <a
            href={item.Url}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="mgmt-item-card__btn"
          >
            Descargar PDF <Icon name="download" size={13} />
          </a>
        </div>
      </article>
    );
  }

  return (
    <article className="mgmt-item-card mgmt-item-card--static">
      <div className="mgmt-item-card__icon mgmt-item-card__icon--form">
        <Icon name={iconName} size={20} />
      </div>
      <div className="mgmt-item-card__body">
        <div className="mgmt-item-card__title">{item.Titulo}</div>
        {item.Descripcion && <div className="mgmt-item-card__desc">{item.Descripcion}</div>}
      </div>
      <div className="mgmt-item-card__action">
        <Link to={linkTo} state={linkState} className="mgmt-item-card__btn">
          Ver <Icon name="arrow-right" size={13} />
        </Link>
      </div>
    </article>
  );
};

const GeneralManagement = ({ handleOnClick, subsection }) => {
  const { state } = useGeneralManagementState();
  const {
    prestacionActiva,
    prestacionGeneral,
    expedienteId,
    gruposPrestacionActiva,
    gruposPrestacionGeneral,
    successGetMyManagement,
    errorGetMyManagement,
    loadinGetMyManagement
  } = state;

  const fromActive = 1;
  const fromGeneral = 2;

  if (subsection === "activa") {
    return (
      <>
        {loadinGetMyManagement && <div className="mgmt-loading"><LoaderMin /></div>}
        {errorGetMyManagement && <NoData message="Error al descargar datos" />}

        {successGetMyManagement &&
          !errorGetMyManagement &&
          prestacionActiva.length === 0 &&
          gruposPrestacionActiva.length === 0 && (
            <NoData message="No hay gestiones de la prestación activa" />
          )}

        {!errorGetMyManagement && prestacionActiva.length > 0 && (
          <div className="mgmt-cards-grid">
            {prestacionActiva.map((item, i) => (
              <GestionCard
                key={`active_${i}`}
                item={item}
                onClickHandler={() => handleOnClick(item.Titulo, item.Url)}
                linkTo="/mis-gestiones/formularios"
                linkState={{ titulo: item.Titulo, id: item.Id, origen: fromActive, expedienteId }}
              />
            ))}
          </div>
        )}

        {!errorGetMyManagement && gruposPrestacionActiva.map((grupo, i) => (
          <div key={`grupo_active_${i}`} className="mgmt-group">
            <div className="mgmt-group__header">
              <div className="mgmt-group__title">{grupo.Titulo}</div>
              {grupo.Descripcion && <p className="mgmt-group__desc">{grupo.Descripcion}</p>}
            </div>
            <div className="mgmt-cards-grid">
              {grupo.Gestiones.map((gestion, j) => (
                <GestionCard
                  key={`active_group_${i}_${j}`}
                  item={gestion}
                  onClickHandler={() => handleOnClick(gestion.Titulo, gestion.Url)}
                  linkTo="/mis-gestiones/formularios"
                  linkState={{ titulo: gestion.Titulo, id: gestion.Id, origen: fromActive, expedienteId }}
                />
              ))}
            </div>
          </div>
        ))}
      </>
    );
  }

  if (subsection === "general") {
    return (
      <>
        {loadinGetMyManagement && <div className="mgmt-loading"><LoaderMin /></div>}
        {errorGetMyManagement && <NoData message="Error al descargar datos" />}

        {successGetMyManagement &&
          !errorGetMyManagement &&
          prestacionGeneral.length === 0 &&
          gruposPrestacionGeneral.length === 0 && (
            <NoData message="No hay gestiones generales" />
          )}

        {!errorGetMyManagement && prestacionGeneral.length > 0 && (
          <div className="mgmt-cards-grid">
            {prestacionGeneral.map((item, i) => (
              <GestionCard
                key={`general_${i}`}
                item={item}
                onClickHandler={() => handleOnClick(item.Titulo, item.Url)}
                linkTo="/mis-gestiones/formularios"
                linkState={{ titulo: item.Titulo, id: item.Id, origen: fromGeneral, expedienteId }}
              />
            ))}
          </div>
        )}

        {!errorGetMyManagement && gruposPrestacionGeneral.map((grupo, i) => (
          <div key={`grupo_general_${i}`} className="mgmt-group">
            <div className="mgmt-group__header">
              <div className="mgmt-group__title">{grupo.Titulo}</div>
              {grupo.Descripcion && <p className="mgmt-group__desc">{grupo.Descripcion}</p>}
            </div>
            <div className="mgmt-cards-grid">
              {grupo.Gestiones.map((gestion, j) => (
                <GestionCard
                  key={`general_group_${i}_${j}`}
                  item={gestion}
                  onClickHandler={() => handleOnClick(gestion.Titulo, gestion.Url)}
                  linkTo="/mis-gestiones/formularios"
                  linkState={{ titulo: gestion.Titulo, id: gestion.Id, origen: fromGeneral, expedienteId }}
                />
              ))}
            </div>
          </div>
        ))}
      </>
    );
  }

  return null;
};

export default GeneralManagement;
